module.exports = __webpack_public_path__ + "static/media/icon_delete_turquoise.63b9c24f.svg";